import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const ServiceHero = ({ onEmergencyClick }) => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-gradient-to-br from-primary via-primary to-secondary text-primary-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-secondary rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-accent/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <Icon name="Award" size={20} />
              <span className="text-sm font-semibold">30+ Years of Proven Expertise</span>
            </div>
            
            <h1 className="font-headline text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Expert Plumbing Services You Can Trust
            </h1>
            
            <p className="font-body text-lg md:text-xl opacity-90 mb-8">
              From emergency leak repairs to complete installations, we deliver professional plumbing solutions backed by three decades of experience and trusted by major brands like McDonald's and KFC.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                className="bg-accent hover:bg-accent/90 text-accent-foreground emergency-cta"
                iconName="Phone"
                iconPosition="left"
                onClick={onEmergencyClick}>

                Emergency: 082 793 5785
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                className="bg-white/10 backdrop-blur-sm border-white/30 hover:bg-white/20"
                iconName="Calendar"
                iconPosition="left"
                onClick={() => navigate('/schedule-service')}>

                Schedule Service
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_196320e5c-1764748518235.png"
                alt="Professional plumber in blue uniform working on modern sink installation with chrome fixtures in bright residential bathroom"
                className="w-full h-full object-cover" />

            </div>
            
            {/* <div className="absolute -bottom-6 -left-6 bg-card text-foreground p-6 rounded-xl shadow-xl max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-12 h-12 bg-success/10 rounded-full flex items-center justify-center">
                  <Icon name="CheckCircle" size={24} color="var(--color-success)" />
                </div>
                <div>
                  <div className="font-semibold">Certified & Licensed</div>
                  <div className="text-sm text-muted-foreground">Licensed Professional</div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>);

};

export default ServiceHero;